module.exports = __webpack_public_path__ + "img/im.8783ce5a.svg";